import { Routes } from '@angular/router';

import { LandingPageComponent } from './modules/landing-page/landing-page/landing-page.component';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { DownloadFileComponent } from './shared/components/firmware/download-file.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: LandingPageComponent,
  },
  {
    path: 'orbis-loader',
    component: DownloadFileComponent,
  },
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth-routes').then((m) => m.authRoutes),
  },
  {
    path: 'admin',
    loadChildren: () => import('./modules/admin/admin-routes').then((m) => m.adminRoutes),
  },
  {
    path: 'client',
    loadChildren: () => import('./modules/client/client-routes').then((m) => m.clientRoutes),
  },
    {
    path: 'privacy-policy',
    loadChildren: () => import('./modules/privacy-policy/privacy-policy-routes').then((m) => m.privacyPolicyRoutes),
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];
